/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IncomingCanonicalLinksQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  limit: GraphQL.Scalars['Int']['input'];
  offset: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IncomingCanonicalLinksQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly legacyId: number | null, readonly incomingCanonicalLinks: { readonly __typename?: 'PageIncomingCanonicalLinksConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PageIncomingCanonicalLinksConnectionEdge', readonly cursor: any, readonly loadedAt: number, readonly node: { readonly __typename?: 'PageIncomingCanonicalLinksConnectionNode', readonly id: CK.ID, readonly sourceId: CK.UrlId, readonly sourceLegacyId: number | null, readonly sourceUrl: string } } | null> } | null } | null };


export const IncomingCanonicalLinksDocument = gql`
    query IncomingCanonicalLinks($legacyUrlId: Int!, $limit: Int!, $offset: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    incomingCanonicalLinks(limit: $limit, offset: $offset) {
      edges {
        cursor
        loadedAt @client
        node {
          id
          sourceId
          sourceLegacyId
          sourceUrl
        }
      }
      totalCount
    }
    legacyId
  }
}
    `;

/**
 * __useIncomingCanonicalLinksQuery__
 *
 * To run a query within a React component, call `useIncomingCanonicalLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingCanonicalLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingCanonicalLinksQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIncomingCanonicalLinksQuery(baseOptions: Apollo.QueryHookOptions<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables> & ({ variables: IncomingCanonicalLinksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>(IncomingCanonicalLinksDocument, options);
      }
export function useIncomingCanonicalLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>(IncomingCanonicalLinksDocument, options);
        }
export function useIncomingCanonicalLinksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>(IncomingCanonicalLinksDocument, options);
        }
export type IncomingCanonicalLinksQueryHookResult = ReturnType<typeof useIncomingCanonicalLinksQuery>;
export type IncomingCanonicalLinksLazyQueryHookResult = ReturnType<typeof useIncomingCanonicalLinksLazyQuery>;
export type IncomingCanonicalLinksSuspenseQueryHookResult = ReturnType<typeof useIncomingCanonicalLinksSuspenseQuery>;
export type IncomingCanonicalLinksQueryResult = Apollo.QueryResult<IncomingCanonicalLinksQuery, IncomingCanonicalLinksQueryVariables>;